module.exports = __webpack_public_path__ + "img/dropDownT.a14c5560.svg";